import { createClient } from "@supabase/supabase-js";

const supabaseUrl = process.env.GATSBY_SUPABASE_URL as string | undefined;
const supabaseAnonKey = process.env.GATSBY_SUPABASE_ANON_KEY as
  | string
  | undefined;

if (!supabaseUrl || !supabaseAnonKey) {
  // In dev this can be undefined; consumers should handle missing client gracefully
  // eslint-disable-next-line no-console
  console.warn(
    "Supabase env vars missing: set GATSBY_SUPABASE_URL and GATSBY_SUPABASE_ANON_KEY",
  );
}

export const supabase =
  supabaseUrl && supabaseAnonKey
    ? createClient(supabaseUrl, supabaseAnonKey)
    : (null as any);
